import { ajax, ajaxSetup, getJSON } from "jquery";
import { confirmAlert } from "react-confirm-alert";
import { IOptions } from "../options";
import { getConfig } from "../components/Utils";
import { ERRORS_MESSAGES } from "../actions";

export interface IHandler {
	(...params: any[]): void;
}

export interface IErrorHandler {
	(jqxhr: any, textStatus: string, error?: any): void;

	// (status: number, error: string): void;
}

export interface IProgressHandler {
	(progress: number): void;
}

export interface IHandlers {
	before?: IHandler;
	success?: IHandler;
	anyway?: IHandler;
	error?: IErrorHandler;
	progress?: IProgressHandler;
}

export interface IFileOptions {
	id: string;
	maxSize: number;
	format: string;
	element: HTMLInputElement;
}

interface RequestOptions {
	url: string;
	method: string;
	contentType?: string | boolean;
	xhr?: () => XMLHttpRequest;
	processData?: boolean;
	data?: any;
}

export interface CompanyProperties {
	name?: string;
	address?: string;
	inn?: string;
	ogrn?: string;
	kpp?: string;
}

export function createApiClient(form_type: string = null, process_id = 0) {
	const formates = {
		PDF: ["PDF"],
		Image: ["JPG", "PNG", "JPEG"],
	};

	ajaxSetup({
		xhrFields: {
			withCredentials: true,
		},
	});

	const config = getConfig();
	if (form_type !== null) {
		config.form_type = form_type;
	}
	if (process_id !== null) {
		config.process_id = process_id;
	}

	return new ApiClient(config, formates, false);
}

export const errorHandler = ({ ...props }, error) => {
	if (!props) return;
	// eslint-disable-next-line prefer-const
	let { status, statusText } = props;
	if (!statusText && !!error) {
		statusText = JSON.parse(error)?.message;
	}

	switch (status) {
		case 401:
			return;
		case 404: {
			window.location.pathname = "/fasttrack/404";
			break;
		}

		default: {
			confirmAlert({
				message:
					ERRORS_MESSAGES?.[status] ??
					(status || statusText ? `${status || ""} ${statusText || ""}` : `Ошибка сервера`),
				buttons: [
					{
						label: "ОК",
						onClick: () => {
							window.location.reload();
						},
					},
				],
			});
			break;
		}
	}
};

export class ApiClient {
	private lock: boolean;

	private options: IOptions;

	private setValueUrl: string;

	private urlApi: string;

	private userApi: string;

	private companiesApi: string;

	private actionUrl: string;

	private filesUrl: string;

	private masterMentorUrl: string;

	private mentorUrl: string;

	private countriesUrl: string;

	public readonly FileFormats: {
		[format: string]: Array<string>;
	};

	constructor(
		options: IOptions,
		formats: {
			[format: string]: Array<string>;
		},
		lock: boolean
	) {
		this.options = options;
		this.setValueUrl = `${this.options.apiUrl}/item/${this.options.form_type}/${this.options.process_id}/`;
		this.actionUrl = `${this.options.apiUrl}/action/${this.options.process_id}/`;
		this.urlApi = this.options.apiUrl;
		this.userApi = this.options.apiUser;
		this.companiesApi = this.options.companyUrl;
		this.filesUrl = `${this.options.filesUrl}/${this.options.form_type}/${this.options.process_id}/`;
		this.masterMentorUrl = this.options.masterMentorUrl;
		this.mentorUrl = this.options.mentorUrl;
		this.countriesUrl = this.options.countriesUrl;

		this.FileFormats = formats;

		this.lock = lock;
	}

	public isLocked() {
		return this.lock;
	}

	public getReportUrl(formId: string, valuesId: string) {
		return `${this.userApi}/report/${formId}/${valuesId}`;
	}

	public getAttachFileUrl(formId: string, valuesId: number, uid: string) {
		return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files`;
	}

	public createSession(formId: string, company: object, handlers: IHandlers) {
		this.send(
			{
				url: `${this.urlApi}/${formId}`,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(company),
			},
			handlers
		);
	}

	public me(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.userApi}/me/`, handlers.success).fail(handlers.error);
	}

	public welcome(props: any, handlers: IHandlers) {
		return this.send(
			{
				url: "/planner/public/v1/welcome",
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify({ ...props }),
			},
			handlers
		);
	}

	public getMMProcessAll(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.masterMentorUrl}/process/all`, handlers.success).always(handlers.anyway).fail(handlers.error);
	}

	public getSlaveMentorsAll(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.masterMentorUrl}/me/slave-mentors/all`, handlers.success)
			.always(handlers.anyway)
			.fail(handlers.error);
	}

	public setMentor(process_id: number, slave_mentor_email: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.masterMentorUrl}/process/assign/${process_id}/${slave_mentor_email}`,
				method: "POST",
			},
			handlers
		);
	}

	public setAllowDefence(process_id: number, allow: boolean, handlers: IHandlers) {
		this.send(
			{
				url: `${this.mentorUrl}/process/item/${process_id}/allow_defence`,
				method: "POST",
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify({
					allow_defence: allow,
				}),
			},
			handlers
		);
	}

	public getMentorProcessAll(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.mentorUrl}/process/all`, handlers.success).always(handlers.anyway).fail(handlers.error);
	}

	public acceptMentorProcess(process_id, accept, comment, handlers: IHandlers) {
		let data;
		if (comment) data = { accept, comment };
		else data = { accept };
		this.send(
			{
				url: `${this.mentorUrl}/process/accept/${process_id}`,
				method: "POST",
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(data),
			},
			handlers
		);
	}

	public getNotify(formId: string, values: number, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/notify/${formId}/${values}`, handlers.success).fail(handlers.error);
	}

	public getHistory(request: number, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/item/${request}/status_history`, handlers.success).fail(handlers.error);
	}

	public company(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.userApi}/company/`, handlers.success).fail(handlers.error);
	}

	public getCompanyORN(inn: string, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.userApi}/company/orn/${inn}`, handlers.success).fail(handlers.error);
	}

	public redirect(_url?: string) {
		window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(window.location.href)}`;
	}

	public singout(_url?: string) {
		window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(window.location.href)}`;
	}

	public sendValues(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/send`,
				method: "POST",
			},
			handlers
		);
	}

	public sendDocument(handlers: IHandlers) {
		this.send(
			{
				url: `${this.setValueUrl}send`,
				method: "POST",
			},
			handlers
		);
	}

	public sendRevoke(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/revoke`,
				method: "POST",
			},
			handlers
		);
	}

	public sendAdditional(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/additional`,
				method: "POST",
			},
			handlers
		);
	}

	public sendPDF(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/pdf`,
				method: "POST",
			},
			handlers
		);
	}

	public cloneRequest(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/clone`,
				method: "POST",
			},
			handlers
		);
	}

	public deleteValues(handlers: IHandlers) {
		this.send(
			{
				url: `${this.actionUrl}/delete`,
				method: "DELETE",
			},
			handlers
		);
	}

	public getFileUrl(controlId: string, fileName: string, timestamp?: number): string {
		const _fileName = timestamp !== undefined ? `${timestamp}/${fileName}` : fileName;

		return encodeURI(
			`${this.options.filesUrl}/${this.options.form_type}/${this.options.process_id}/${controlId}/${_fileName}`
		);
	}

	public setValue(id: string, value: any, handlers: IHandlers = null) {
		handlers.error = errorHandler;

		this.send(
			{
				url: this.setValueUrl + id,
				method: "POST",
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify({
					timestamp: Date.now(),
					value: typeof value === "object" ? JSON.stringify(value) : value,
				}),
			},
			handlers
		);
	}

	public setValueSync(id: string, value: any, handlers: IHandlers = null) {
		this.send(
			{
				url: `${this.setValueUrl}/${id}`,
				method: "POST",
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify({
					timestamp: Date.now(),
					value,
				}),
			},
			handlers,
			false
		);
	}

	public putValue(id: string, value: any, handlers: IHandlers = null): number {
		const timestamp = Date.now();

		this.send(
			{
				url: `${this.setValueUrl}/${id}`,
				method: "PUT",
				contentType: "application/json",
				data: JSON.stringify({
					timestamp,
					value,
				}),
			},
			handlers
		);
		return timestamp;
	}

	public removeValue(id: string, timestamp: number, handlers: IHandlers = null) {
		this.send(
			{
				url: this.setValueUrl + id /* + "/?timestamp=" + timestamp, */,
				method: "DELETE",
			},
			handlers
		);
	}

	public removeReportPdf(formId: string, values: string, handlers: IHandlers = null) {
		this.send(
			{
				url: `${this.options.apiUrl}/${formId}/${values}/report`,
				method: "DELETE",
			},
			handlers
		);
	}

	// TODO: there is no default return
	// eslint-disable-next-line consistent-return
	public setFileValue(options: IFileOptions, value: any, fileId: string, handlers: IHandlers): string {
		const file = options.element.files[0];
		if (file === undefined || file === null) {
			return null;
		}

		const data = new FormData();
		data.append("file", file);
		data.append("value", value);
		data.append("fileId", fileId);

		let success: IHandler = null;
		if (handlers !== null && handlers.success !== null) {
			success = handlers.success;
			handlers.success = function (res) {
				success(res);
			};
		}

		this.send(
			{
				xhr(): XMLHttpRequest {
					const xhr = new XMLHttpRequest();
					if (handlers !== null && handlers.progress !== null) {
						xhr.upload.addEventListener("progress", (e) => {
							handlers.progress((e.loaded / e.total) * 100);
						});
					}
					return xhr;
				},
				url: `${this.filesUrl + options.id}/file`,
				method: "POST",
				contentType: false,
				data,
				processData: false,
			},
			handlers
		);
	}

	public deleteFileValue(id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) {
		this.send(
			{
				url: encodeURI(`${this.filesUrl + id}/${fileId}`),
				method: "DELETE",
			},
			handlers
		);
	}

	public getFormByUid(id: string, values: number, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/${id}/${values}`, handlers.success).fail(handlers.error);
	}

	public getAllValues(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(this.urlApi, handlers.success).fail(handlers.error);
	}

	public getForms(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/all/`, handlers.success).always(handlers.anyway).fail(handlers.error);
	}

	public getSettings(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/settings`, handlers.success).always(handlers.anyway).fail(handlers.error);
	}

	// public openForm(valuesId: string, formId: string, handlers: IHandlers) {
	//     getJSON(`${this.urlApi}/values/${valuesId}/${formId}`, handlers.success)
	//         .fail(handlers.error);
	// }
	//

	public getFlows(showall: boolean, handlers: IHandlers) {
		if (!handlers.error) {
			handlers.error = errorHandler;
		}
		getJSON(`${this.urlApi}/flows${showall ? "?show=all" : ""}`, handlers.success)
			.fail(handlers.error)
			.always(handlers.anyway);
	}

	public getFlowByDirection(directionId: number, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/flows/direction/${directionId}?show=all`, handlers.success)
			.fail(handlers.error)
			.always(handlers.anyway);
	}

	public getDirections(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.urlApi}/directions`, handlers.success).fail(handlers.error).always(handlers.anyway);
	}

	public createForm(data: object, handlers: IHandlers) {
		this.send(
			{
				url: `${this.urlApi}/item/create/`,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(data),
			},
			handlers
		);
	}

	public createStatusForm(form_type, process_id, data, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/item/to_status/${form_type}/${process_id}`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data)
        }, handlers);
    }

	public rejectApplication(process_id: number, comment: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.masterMentorUrl}/process/reject/${process_id}`,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify({ comment }),
			},
			handlers
		);
	}

	public copyForm(form_type: string, process_id: number, handlers: IHandlers) {
		this.send(
			{
				url: `${this.urlApi}/item/clone/${form_type}/${process_id}`,
				method: "POST",
			},
			handlers
		);
	}

	public revokeForm(form_type: string, process_id: number, handlers: IHandlers) {
		this.send(
			{
				url: `${this.urlApi}/item/revoke/${form_type}/${process_id}`,
				method: "POST",
			},
			handlers
		);
	}

	public deleteForm(form_type: string, process_id: number, handlers: IHandlers) {
		this.send(
			{
				url: `${this.urlApi}/item/${form_type}/${process_id}`,
				method: "DELETE",
			},
			handlers
		);
	}

	public openForm(form_type: string, process_id: number, is_mentor: boolean, handlers: IHandlers) {
		if (!is_mentor) {
			getJSON(`${this.urlApi}/item/${form_type}/${process_id}`, handlers.success)
				.fail(handlers.error)
				.always(handlers.anyway);
		} else {
			getJSON(`${this.mentorUrl}/process/item/${process_id}`, handlers.success)
				.fail(handlers.error)
				.always(handlers.anyway);
		}
	}

	public companyInfo(inn: string, handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.userApi}/company/${inn}`, handlers.success).fail(handlers.error);
	}

	public companyGetByParamsSuggest(object: CompanyProperties, handlers: IHandlers) {
		this.send(
			{
				url: `${this.companiesApi}/get_by_params`,
				method: "POST",
				contentType: "application/json",
				data: JSON.stringify(object),
			},
			handlers
		);
	}

	public suggest(text: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.companiesApi}/suggest/${text}`,
				method: "GET",
				contentType: "application/json",
			},
			handlers
		);
	}

	public getCompanies(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.companiesApi}/data/`, handlers.success).fail(handlers.error).always(handlers.anyway);
	}

	public getValue(controlId: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.setValueUrl}/${controlId}`,
				method: "GET",
			},
			handlers
		);
	}

	public getDynamicOptions = (handlers, formType: string, selectType: string) => {
		getJSON(`${this.urlApi}/reference/${formType}/${selectType}`, handlers.success);
	};

	public getAppointedStatus = ({ process_id }, handlers) => {
		getJSON(`${this.mentorUrl}/process/appointment/${process_id}`, handlers.success);
	};

	public getCountries(handlers: IHandlers) {
		if (!handlers.error) handlers.error = errorHandler;
		getJSON(`${this.countriesUrl}/list/`, handlers.success).fail(handlers.error).always(handlers.anyway);
	}

	public isRemovePanelBlock(key: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.setValueUrl}/${key}/isremove`,
				method: "GET",
			},
			handlers
		);
	}

	public hasRemoveBlock(key: string, handlers: IHandlers) {
		this.send(
			{
				url: `${this.setValueUrl}/${key}/hasremove`,
				method: "GET",
			},
			handlers
		);
	}

	// eslint-disable-next-line class-methods-use-this
	private send(options: RequestOptions, handlers: IHandlers, async = true) {
		let success: IHandler = null;
		let error: IErrorHandler = null;

		if (handlers) {
			success = handlers.success;
			error = handlers.error;
		}
		if (!handlers.error) {
			handlers.error = errorHandler;
		}

		ajax({
			xhr: options.xhr,
			url: options.url,
			type: options.method,
			contentType: options.contentType,
			data: options.data,
			processData: options.processData,
			success,
			async,
			error(jqXHR: JQueryXHR) {
				if (error !== null) error(jqXHR.status, jqXHR.responseText);
			},
		});
	}

	private static getFileExtension(fileName: string) {
		return fileName.substring(fileName.lastIndexOf(".") + 1).toUpperCase();
	}
}
